module.exports = __webpack_public_path__ + "img/10894_L.ac46145a.png";